import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { renderPrevIcon as he, renderNextIcon as me, renderCloseIcon as ve } from "./icons.js";
import { imagePreviewSharedProps as we, imageContextKey as pe } from "./interface.js";
import ge from "./styles/index.cssr.js";
import xe from "../../_mixins/use-theme.js";
import { imageLight as be } from "../styles/light.js";
import Ce from "../../_mixins/use-locale.js";
import { on as B, off as N } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import Se from "../../_mixins/use-config.js";
import { useThemeClass as ke } from "../../_mixins/use-css-vars-class.js";
import Pe from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import p from "../../_internal/icon/src/Icon.js";
import Ie from "../../_internal/icons/RotateCounterclockwise.js";
import ye from "../../_internal/icons/RotateClockwise.js";
import ze from "../../_internal/icons/ResizeSmall.js";
import Oe from "../../_internal/icons/ZoomOut.js";
import Re from "../../_internal/icons/Download.js";
import Me from "../../_internal/icons/ZoomIn.js";
import De from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/lazy-teleport/src/index.js";
import Te from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/zindexable/index.js";
import $e from "../../../../../../lodash-es@4.17.21/node_modules/lodash-es/kebabCase.js";
import Ne from "../../tooltip/src/Tooltip.js";
import { beforeNextFrameOnce as He } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/animation/next-frame-once.js";
import { defineComponent as We, watch as Xe, onBeforeUnmount as Ye, inject as _e, computed as Be, h as i, withDirectives as J, Fragment as L } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as Le, ref as D } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { Transition as E, vShow as Ee } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { download as Ve } from "../../_utils/dom/download.js";
import { normalizeStyle as Ae } from "../../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const H = 32, xt = We({
  name: "ImagePreview",
  props: Object.assign(Object.assign({}, we), {
    onNext: Function,
    onPrev: Function,
    clsPrefix: {
      type: String,
      required: !0
    }
  }),
  setup(a) {
    const C = xe("Image", "-image", ge, be, a, Le(a, "clsPrefix"));
    let r = null;
    const g = D(null), f = D(null), S = D(void 0), b = D(!1), k = D(!1), {
      localeRef: T
    } = Ce("Image");
    function $() {
      const {
        value: e
      } = f;
      if (!r || !e)
        return;
      const {
        style: o
      } = e, t = r.getBoundingClientRect(), n = t.left + t.width / 2, l = t.top + t.height / 2;
      o.transformOrigin = `${n}px ${l}px`;
    }
    function P(e) {
      var o, t;
      switch (e.key) {
        case " ":
          e.preventDefault();
          break;
        case "ArrowLeft":
          (o = a.onPrev) === null || o === void 0 || o.call(a);
          break;
        case "ArrowRight":
          (t = a.onNext) === null || t === void 0 || t.call(a);
          break;
        case "Escape":
          K();
          break;
      }
    }
    Xe(b, (e) => {
      e ? B("keydown", document, P) : N("keydown", document, P);
    }), Ye(() => {
      N("keydown", document, P);
    });
    let R = 0, M = 0, w = 0, h = 0, I = 0, W = 0, V = 0, A = 0, X = !1;
    function U(e) {
      const {
        clientX: o,
        clientY: t
      } = e;
      w = o - R, h = t - M, He(m);
    }
    function Q(e) {
      const {
        mouseUpClientX: o,
        mouseUpClientY: t,
        mouseDownClientX: n,
        mouseDownClientY: l
      } = e, d = n - o, u = l - t, v = `vertical${u > 0 ? "Top" : "Bottom"}`, x = `horizontal${d > 0 ? "Left" : "Right"}`;
      return {
        moveVerticalDirection: v,
        moveHorizontalDirection: x,
        deltaHorizontal: d,
        deltaVertical: u
      };
    }
    function j(e) {
      const {
        value: o
      } = g;
      if (!o)
        return {
          offsetX: 0,
          offsetY: 0
        };
      const t = o.getBoundingClientRect(), {
        moveVerticalDirection: n,
        moveHorizontalDirection: l,
        deltaHorizontal: d,
        deltaVertical: u
      } = e || {};
      let v = 0, x = 0;
      return t.width <= window.innerWidth ? v = 0 : t.left > 0 ? v = (t.width - window.innerWidth) / 2 : t.right < window.innerWidth ? v = -(t.width - window.innerWidth) / 2 : l === "horizontalRight" ? v = Math.min((t.width - window.innerWidth) / 2, I - (d != null ? d : 0)) : v = Math.max(-((t.width - window.innerWidth) / 2), I - (d != null ? d : 0)), t.height <= window.innerHeight ? x = 0 : t.top > 0 ? x = (t.height - window.innerHeight) / 2 : t.bottom < window.innerHeight ? x = -(t.height - window.innerHeight) / 2 : n === "verticalBottom" ? x = Math.min((t.height - window.innerHeight) / 2, W - (u != null ? u : 0)) : x = Math.max(-((t.height - window.innerHeight) / 2), W - (u != null ? u : 0)), {
        offsetX: v,
        offsetY: x
      };
    }
    function F(e) {
      N("mousemove", document, U), N("mouseup", document, F);
      const {
        clientX: o,
        clientY: t
      } = e;
      X = !1;
      const n = Q({
        mouseUpClientX: o,
        mouseUpClientY: t,
        mouseDownClientX: V,
        mouseDownClientY: A
      }), l = j(n);
      w = l.offsetX, h = l.offsetY, m();
    }
    const s = _e(pe, null);
    function ee(e) {
      var o, t;
      if ((t = (o = s == null ? void 0 : s.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.onMousedown) === null || t === void 0 || t.call(o, e), e.button !== 0)
        return;
      const {
        clientX: n,
        clientY: l
      } = e;
      X = !0, R = n - w, M = l - h, I = w, W = h, V = n, A = l, m(), B("mousemove", document, U), B("mouseup", document, F);
    }
    const Y = 1.5;
    let y = 0, c = 1, z = 0;
    function te(e) {
      var o, t;
      (t = (o = s == null ? void 0 : s.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.onDblclick) === null || t === void 0 || t.call(o, e);
      const n = Z();
      c = c === n ? 1 : n, m();
    }
    function _() {
      c = 1, y = 0;
    }
    function oe() {
      var e;
      _(), z = 0, (e = a.onPrev) === null || e === void 0 || e.call(a);
    }
    function ie() {
      var e;
      _(), z = 0, (e = a.onNext) === null || e === void 0 || e.call(a);
    }
    function ne() {
      z -= 90, m();
    }
    function le() {
      z += 90, m();
    }
    function re() {
      const {
        value: e
      } = g;
      if (!e)
        return 1;
      const {
        innerWidth: o,
        innerHeight: t
      } = window, n = Math.max(1, e.naturalHeight / (t - H)), l = Math.max(1, e.naturalWidth / (o - H));
      return Math.max(3, n * 2, l * 2);
    }
    function Z() {
      const {
        value: e
      } = g;
      if (!e)
        return 1;
      const {
        innerWidth: o,
        innerHeight: t
      } = window, n = e.naturalHeight / (t - H), l = e.naturalWidth / (o - H);
      return n < 1 && l < 1 ? 1 : Math.max(n, l);
    }
    function ae() {
      const e = re();
      c < e && (y += 1, c = Math.min(e, Math.pow(Y, y)), m());
    }
    function se() {
      if (c > 0.5) {
        const e = c;
        y -= 1, c = Math.max(0.5, Math.pow(Y, y));
        const o = e - c;
        m(!1);
        const t = j();
        c += o, m(!1), c -= o, w = t.offsetX, h = t.offsetY, m();
      }
    }
    function ce() {
      const e = S.value;
      e && Ve(e, void 0);
    }
    function m(e = !0) {
      var o;
      const {
        value: t
      } = g;
      if (!t)
        return;
      const {
        style: n
      } = t, l = Ae((o = s == null ? void 0 : s.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.style);
      let d = "";
      if (typeof l == "string")
        d = `${l};`;
      else
        for (const v in l)
          d += `${$e(v)}: ${l[v]};`;
      const u = `transform-origin: center; transform: translateX(${w}px) translateY(${h}px) rotate(${z}deg) scale(${c});`;
      X ? n.cssText = `${d}cursor: grabbing; transition: none;${u}` : n.cssText = `${d}cursor: grab;${u}${e ? "" : "transition: none;"}`, e || t.offsetHeight;
    }
    function K() {
      b.value = !b.value, k.value = !0;
    }
    function de() {
      c = Z(), y = Math.ceil(Math.log(c) / Math.log(Y)), w = 0, h = 0, m();
    }
    const fe = {
      setPreviewSrc: (e) => {
        S.value = e;
      },
      setThumbnailEl: (e) => {
        r = e;
      },
      toggleShow: K
    };
    function ue(e, o) {
      if (a.showToolbarTooltip) {
        const {
          value: t
        } = C;
        return i(Ne, {
          to: !1,
          theme: t.peers.Tooltip,
          themeOverrides: t.peerOverrides.Tooltip,
          keepAliveOnHover: !1
        }, {
          default: () => T.value[o],
          trigger: () => e
        });
      } else
        return e;
    }
    const q = Be(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          toolbarIconColor: o,
          toolbarBorderRadius: t,
          toolbarBoxShadow: n,
          toolbarColor: l
        }
      } = C.value;
      return {
        "--n-bezier": e,
        "--n-toolbar-icon-color": o,
        "--n-toolbar-color": l,
        "--n-toolbar-border-radius": t,
        "--n-toolbar-box-shadow": n
      };
    }), {
      inlineThemeDisabled: G
    } = Se(), O = G ? ke("image-preview", void 0, q, a) : void 0;
    return Object.assign({
      previewRef: g,
      previewWrapperRef: f,
      previewSrc: S,
      show: b,
      appear: Pe(),
      displayed: k,
      previewedImgProps: s == null ? void 0 : s.previewedImgPropsRef,
      handleWheel(e) {
        e.preventDefault();
      },
      handlePreviewMousedown: ee,
      handlePreviewDblclick: te,
      syncTransformOrigin: $,
      handleAfterLeave: () => {
        _(), z = 0, k.value = !1;
      },
      handleDragStart: (e) => {
        var o, t;
        (t = (o = s == null ? void 0 : s.previewedImgPropsRef.value) === null || o === void 0 ? void 0 : o.onDragstart) === null || t === void 0 || t.call(o, e), e.preventDefault();
      },
      zoomIn: ae,
      zoomOut: se,
      handleDownloadClick: ce,
      rotateCounterclockwise: ne,
      rotateClockwise: le,
      handleSwitchPrev: oe,
      handleSwitchNext: ie,
      withTooltip: ue,
      resizeToOrignalImageSize: de,
      cssVars: G ? void 0 : q,
      themeClass: O == null ? void 0 : O.themeClass,
      onRender: O == null ? void 0 : O.onRender
    }, fe);
  },
  render() {
    var a, C;
    const {
      clsPrefix: r,
      renderToolbar: g,
      withTooltip: f
    } = this, S = f(i(p, {
      clsPrefix: r,
      onClick: this.handleSwitchPrev
    }, {
      default: he
    }), "tipPrevious"), b = f(i(p, {
      clsPrefix: r,
      onClick: this.handleSwitchNext
    }, {
      default: me
    }), "tipNext"), k = f(i(p, {
      clsPrefix: r,
      onClick: this.rotateCounterclockwise
    }, {
      default: () => i(Ie, null)
    }), "tipCounterclockwise"), T = f(i(p, {
      clsPrefix: r,
      onClick: this.rotateClockwise
    }, {
      default: () => i(ye, null)
    }), "tipClockwise"), $ = f(i(p, {
      clsPrefix: r,
      onClick: this.resizeToOrignalImageSize
    }, {
      default: () => i(ze, null)
    }), "tipOriginalSize"), P = f(i(p, {
      clsPrefix: r,
      onClick: this.zoomOut
    }, {
      default: () => i(Oe, null)
    }), "tipZoomOut"), R = f(i(p, {
      clsPrefix: r,
      onClick: this.handleDownloadClick
    }, {
      default: () => i(Re, null)
    }), "tipDownload"), M = f(i(p, {
      clsPrefix: r,
      onClick: this.toggleShow
    }, {
      default: ve
    }), "tipClose"), w = f(i(p, {
      clsPrefix: r,
      onClick: this.zoomIn
    }, {
      default: () => i(Me, null)
    }), "tipZoomIn");
    return i(L, null, (C = (a = this.$slots).default) === null || C === void 0 ? void 0 : C.call(a), i(De, {
      show: this.show
    }, {
      default: () => {
        var h;
        return this.show || this.displayed ? ((h = this.onRender) === null || h === void 0 || h.call(this), J(i("div", {
          class: [`${r}-image-preview-container`, this.themeClass],
          style: this.cssVars,
          onWheel: this.handleWheel
        }, i(E, {
          name: "fade-in-transition",
          appear: this.appear
        }, {
          default: () => this.show ? i("div", {
            class: `${r}-image-preview-overlay`,
            onClick: this.toggleShow
          }) : null
        }), this.showToolbar ? i(E, {
          name: "fade-in-transition",
          appear: this.appear
        }, {
          default: () => this.show ? i("div", {
            class: `${r}-image-preview-toolbar`
          }, g ? g({
            nodes: {
              prev: S,
              next: b,
              rotateCounterclockwise: k,
              rotateClockwise: T,
              resizeToOriginalSize: $,
              zoomOut: P,
              zoomIn: w,
              download: R,
              close: M
            }
          }) : i(L, null, this.onPrev ? i(L, null, S, b) : null, k, T, $, P, w, R, M)) : null
        }) : null, i(E, {
          name: "fade-in-scale-up-transition",
          onAfterLeave: this.handleAfterLeave,
          appear: this.appear,
          // BUG:
          // onEnter will be called twice, I don't know why
          // Maybe it is a bug of vue
          onEnter: this.syncTransformOrigin,
          onBeforeLeave: this.syncTransformOrigin
        }, {
          default: () => {
            const {
              previewedImgProps: I = {}
            } = this;
            return J(i("div", {
              class: `${r}-image-preview-wrapper`,
              ref: "previewWrapperRef"
            }, i("img", Object.assign({}, I, {
              draggable: !1,
              onMousedown: this.handlePreviewMousedown,
              onDblclick: this.handlePreviewDblclick,
              class: [`${r}-image-preview`, I.class],
              key: this.previewSrc,
              src: this.previewSrc,
              ref: "previewRef",
              onDragstart: this.handleDragStart
            }))), [[Ee, this.show]]);
          }
        })), [[Te, {
          enabled: this.show
        }]])) : null;
      }
    }));
  }
});
export {
  xt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/image/src/ImagePreview.js
// module id = 920
// module chunks = 41